import { create } from 'zustand';
import { nanoid } from 'nanoid';
import { useInvoices } from '../../useInvoices';
import { showToast } from 'Components/Toast';
import api from '../../../../../api';

export let useItemsBlock = create((set, get) => ({
	itemHandler: (value, rowIndex, colIndex) => {
		const currentState = useInvoices.getState();
		const updatedItems = currentState.form.invoice_items.map((row) => [...row]);
		updatedItems[rowIndex][colIndex] = value;

		useInvoices.setState({
			form: {
				...currentState.form,
				invoice_items: updatedItems,
			},
		});
	},

	addItem: () => {
		const currentState = useInvoices.getState();
		const newItem = currentState.form.invoice_items_title.map(() => ''); // Match the length of itemsTitles
		useInvoices.setState((state) => ({
			form: {
				...state.form,
				invoice_items: [...state.form.invoice_items, newItem],
			},
		}));
	},

	deleteItem: (rowIndex) => {
		useInvoices.setState((state) => {
			const updatedItems = state.form.invoice_items.filter((_, index) => index !== rowIndex);
			return {
				form: {
					...state.form,
					invoice_items: updatedItems,
				},
			};
		});
	},

	addHeader: (index) => {
		useInvoices.setState((state) => {
			const updatedTitles = [
				...state.form.invoice_items_title.slice(0, index),
				'New' + index,
				...state.form.invoice_items_title.slice(index),
			];

			const updatedItems = state.form.invoice_items.map((row) => [...row.slice(0, index), '', ...row.slice(index)]);

			return {
				form: {
					...state.form,
					invoice_items_title: updatedTitles,
					invoice_items: updatedItems,
				},
			};
		});
	},

	addHeaderLast: () => {
		useInvoices.setState((state) => {
			const updatedTitles = [...state.form.invoice_items_title, `Col ${state.form.invoice_items_title.length + 1}`];
			const updatedItems = state.form.invoice_items.map((row) => [...row, '']);
			return {
				form: {
					...state.form,
					invoice_items_title: updatedTitles,
					invoice_items: updatedItems,
				},
			};
		});
	},

	deleteHeader: (colIndex) => {
		useInvoices.setState((state) => {
			const updatedTitles = state.form.invoice_items_title.filter((_, index) => index !== colIndex);
			const updatedItems = state.form.invoice_items.map((row) => row.filter((_, index) => index !== colIndex));
			return {
				form: {
					...state.form,
					invoice_items_title: updatedTitles,
					invoice_items: updatedItems,
				},
			};
		});
	},

	onUpdateTitle: (index, newValue) => {
		useInvoices.setState((state) => {
			let updatedTitles = [...state.form.invoice_items_title];
			updatedTitles[index] = newValue;

			return {
				form: {
					...state.form,
					invoice_items_title: updatedTitles,
				},
			};
		});
	},
}));
